<template>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="button_back" @click="goBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title v-if="job.startDate">
      <template v-if="checkJobDateStart(job.startDate, job.endDate)">
        <span>{{ checkJobDateStart(job.startDate, job.endDate, true) }}</span>
      </template>
     
    </ion-title>
    </ion-toolbar>
    <div v-if="loading" class="loading-screen">
     
    </div>
      <div v-else class="main_wrapper ion-padding">
      <div class="job_info_wrapper">
        <div class="rate_shifts_info">
        <div class="info_wrapper">
          <div class="info_title">Hourly rate (excluding super)</div>
          <div class="info_value" v-if="userRole == 'pharmacy'">
            {{ formatHourlyRatePharmacy() }}
          </div>
        </div>
        <div class="info_wrapper">
          <div class="info_title">Available shifts</div>
          <div class="info_value">
            <span>{{ checkJobDateStart(job.startDate, job.endDate) }}</span>-
            <span>{{$moment(job.endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("D MMMM")}}</span>
          </div>
        </div>
        <div class="info_wrapper" v-if="userRole == 'pharmacy' && job.settings.payingForTravel == 3 && job.maxTravelCompensation!==0" >
          <div class="info_title">Capped Travel</div>
          <div class="info_value">
            <span>${{ job.maxTravelCompensation }}</span>
          </div>
        </div>
      </div>
        <el-collapse class="mt-3 job-about-collapse" accordion @change="handleChange">
          <el-collapse-item class="card-accordeon" title="More about the job" name="first">
            <div class="collapse-list more-info">
              <div class="collapse-item" v-if="!job.isInternalStaffOfThisPharmacy || job.isVisibileAsInternalLocum === false">
                <span class="collapse-title">Hourly Rate (excluding super)</span>
                <span class="collapse-value">
                  {{
                    formatHourlyRate(
                      job.recommendedRate,
                      job.recommendedWeekendRate
                    )
                  }}</span>
              </div>
              <div v-if="job.settings.language" class="collapse-item">
                <span class="collapse-title">Language</span>
                <span class="collapse-value">{{ job.settings.language }}</span>
              </div>
  
              <div class="collapse-item">
                <span class="collapse-title">Solo Pharmacist</span>
                <span class="collapse-value">{{
                  job.settings.solo == 1 ? "Yes" : "No"
                }}</span>
              </div>
  
              <div class="collapse-item">
                <span class="collapse-title">{{ message.Immuniser }} req?</span>
                <span class="collapse-value">{{
                  job.covidCertRequired == 0
                  ? "Not Required"
                  : job.covidCertRequired == 1
                    ? "Mandatory"
                    : "Nice to Have"
                }}</span>
              </div>
  
              <div class="collapse-item">
                <span class="collapse-title">Number of technicians</span>
                <span class="collapse-value">{{ job.settings.numOfTech }}</span>
              </div>
              <div class="collapse-item" v-if="job.settings.payingForTravel == 3 && job.maxTravelCompensation !== 0">
                <span class="collapse-title">Pay for Travel</span>
                <span class="collapse-value">Capped Travel</span>
              </div>
              <div class="collapse-item" v-else>
                <span class="collapse-title">Pay for Travel (>50KM roundtrip)</span>
                <span class="collapse-value">{{
                  job.settings.payingForTravel == 0
                  ? "No travel"
                  : job.settings.payingForTravel == 1
                    ? "Partial travel"
                    : "Full travel"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Flights</span>
                <span class="collapse-value">{{
                  job.settings.payForFlights == 0 ? "No" : "Yes"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Accommodation</span>
                <span class="collapse-value">{{
                  job.settings.payForAccommodation == 0 ? "No" : "Yes"
                }}</span>
              </div>
              <div class="collapse-item" v-if="isAustralia">
                <span class="collapse-title">Dosage Administration Aids</span>
                <span class="collapse-value">{{
                  job.settings.adminAids == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Open Pharmacy</span>
                <span class="collapse-value">{{
                  job.settings.openUp == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Close Pharmacy</span>
                <span class="collapse-value">{{
                  job.settings.close == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div v-if="job.settings.notes" class="collapse-item collapse-item--notes">
                <span class="collapse-title">Notes</span>
                <p class="job-notes__content">{{ job.settings.notes }}</p>
              </div>
              <div v-if="job.settings.parking" class="collapse-item collapse-item--notes">
                <span class="collapse-title">Parking</span>
                <p class="job-notes__content">{{ job.settings.parking }}</p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <el-form class="job_shifts_wrapper full_page" :label-position="'top'" @submit.prevent="submit()">
        <el-form-item class="mb0" prop="jobShifts">
          <div :class="shift.confirmedHours ? 'confirmedHours' : ''" class="job_shift_text">
            <div class="job_shift_text__item">
              <div class="day_name">
                {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("ddd") }},
                {{ $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]).format("D MMM, YYYY") }}
              </div>
              <div class="day_time">
                <span>{{
                  $moment(shift.startTime, "HH:mm").format("h:mm A")
                }}</span>
                -
                <span>{{
                  $moment(shift.endTime, "HH:mm").format("h:mm A")
                }}</span>
              </div>
            </div>
            <div style="display:flex; gap:1.6rem">
              <div class="job_shift_text__item">
                <div class="day_name">Rate</div>
                <div class="day_time">
                  <span v-if="showShiftInformation(shift)">
                    -</span>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="job_shift_text__item">
                <div class="day_name">Hours</div>
                <div class="day_time">
                  <span v-if="showShiftInformation(shift)">
                    {{
                      confirmedHours(
                        shift.confirmedHours,
                        shift.startTime,
                        shift.endTime
                      )
                    }}</span>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="job_shift_text__item"
                v-if="!job.isInternalStaffOfThisPharmacy || shift.isVisibileAsInternalLocum === false">
                <div class="day_name" v-if="job.settings.payingForTravel == 3 && job.maxTravelCompensation !== 0">
                  <span>Capped Travel</span>
                </div>
                <div class="day_name" v-else>
                  <span>Travel</span>
                </div>
                <div class="day_time">
                  <span v-if="showShiftInformation(shift)">
                    {{ travelCompensationCount(job, shift) }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="job_shift_text__item"
                v-if="!job.isInternalStaffOfThisPharmacy || shift.isVisibileAsInternalLocum === false">
                <div class="day_name">Sum</div>
                <div class="day_time">
                  <span v-if="showShiftInformation(shift)">
                    {{ Sum(shift) }}</span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="jobShiftsErrors" class="button_submit mb0">
          <el-button class="submit_page" type="danger" @click="rejectSubmit()" :disabled="isButtonDisabled">
            Decline
          </el-button>
          <el-button class="submit_page" type="success" @click="submit()" :disabled="isButtonDisabled">
            Offer
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  
    <div class="el_dialog_wraper">
      <el-dialog v-model="dialogVisible" title="Shift Accepted" width="30%" @closed="handleDialogClose">
        <div class="message text-center mt-3">
          <p>Congratulations!</p>
          <p>We'll let the locum know you have rewared the shift</p>
          <img style="width: 200px" class="success_image" width="100%" src="@/assets/img/illustrations/success.svg"
            alt="success image" />
        </div>
        <template #footer>
          <span class="dialog-footer w-100">
            <el-button @click="redirectToCalendar" type="primary">View Calendar</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  
    <div class="el_dialog_wraper">
      <el-dialog v-model="rejectDialogVisible" title="" width="30%" @closed="handleDialogClose">
        <div class="message text-center mt-3">
          <p>We'll let the locum know you have declined the shift</p>
        </div>
        <template #footer>
          <span class="dialog-footer w-100">
            <el-button @click="redirectToCalendar" type="primary">View Calendar</el-button>
          </span>
        </template>
      </el-dialog>
    </div>

    
  </template>
  <script>
  import { ref, onMounted, inject, computed, onBeforeMount } from "vue";
  import { addIcons } from "ionicons";
  import { arrowBackOutline } from "ionicons/icons";
  import { useStore } from "vuex";
  import moment from "moment";
  import timeDiff from "@/helpers/date/timeDiff";
  import timeDiffAsDecimal from "@/helpers/date/timeDiffAsDecimal";
  import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";
  import { useRouter,useRoute } from "vue-router";
  import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

  addIcons({
    "arrow-back-outline": arrowBackOutline,
  });
  
  import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
  } from "@ionic/vue";
  
  export default {
    components: {
      IonToolbar,
      IonButton,
      IonButtons,
      IonIcon,
      IonTitle,
    },

    setup() {
      const $store = useStore();
      const $router = useRouter();
      const $route = useRoute();
      const setPageClassGlobal = inject("setPageClassGlobal");
      const dialogVisible = ref(false);
      const rejectDialogVisible = ref(false);
      const isAustralia = isAustraliaRegion();
      const message = inject("messages");

      
      let shiftApplication = ref({});
      let shift = ref();
      let job = ref();
      let pharmacy = ref();
      const loading = ref(true);
      const userData = $store.getters.GET_USER_DATA;
      const userRole = userData.role;

      onBeforeMount(async () => {
        console.log("iam urgent from view on beforemount");
        try {
            const id = $route.params.shiftAppId;
            console.log("🚀 ~ file: ProfileView.vue:74 ~ returnnewPromise ~ id:", id);

            const response = await $store.dispatch("GET_AWARD_SHIFT_DETAIL_INFO", {
              shiftAppId: $route.params.shiftAppId,
              pharmacyId: $route.params.pharmacyId,
              locumId: $route.params.locumId,
                    });

            shiftApplication.value = response.data;
            shift.value = shiftApplication.value.shift;
     
            job.value = shift.value.job;
      
            pharmacy = shift.value.pharmacy;
            loading.value = false;
        } catch (error) {
            console.error("Error fetching user data:", error);
            // Hide the loading screen if an error occurs
            loading.value = false;
        }
    });

    const goBack = () => {
      $router.push({
        name: 'search',
      });
    };
  
      onMounted(() => {
        setPageClassGlobal("shift_application_preview");
        console.log("hellloooo")
      });

      const checkJobDateStart = (dateStart, endDate, trim) => {
      let start = moment(dateStart, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]);
      let end = moment(endDate, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss.SSSZ", "DD MMM YYYY"]);
      if (start.format("MMMM") == end.format("MMMM")) {
        if (start.format("D") == end.format("D")) {
          return start.format("D " + (trim ? "MMM" : "MMMM"));
        }
        return (
          start.format("D ") +
          " - " +
          end.format("D " + (trim ? "MMM" : "MMMM"))
        );
      } else {
        return (
          start.format("D " + (trim ? "MMM" : "MMMM")) +
          " - " +
          end.format("D " + (trim ? "MMM" : "MMMM"))
        );
      }
    };

      const formatHourlyRatePharmacy = () => {
      const rateArray = [];

      if (job.value.minRate) {
        rateArray.push(job.value.minRate);
      }
      if (job.value.maxRate) {
        rateArray.push(job.value.maxRate);
      }
      if (job.value.weekendMaxRate) {
        rateArray.push(job.value.weekendMaxRate);
      }
      if (job.value.weekendMinRate) {
        rateArray.push(job.value.weekendMinRate);
      }
      if (job.value.saturdayMinRate) {
        rateArray.push(job.value.saturdayMinRate);
      }
      if (job.value.saturdayMaxRate) {
        rateArray.push(job.value.saturdayMaxRate);
      }
      if (job.value.sundayMinRate) {
        rateArray.push(job.value.sundayMinRate);
      }
      if (job.value.sundayMaxRate) {
        rateArray.push(job.value.sundayMaxRate);
      }



      rateArray.sort((a, b) => a - b);
      const firstEl = rateArray.shift();
      const lastEl = rateArray.pop();
      return (
        new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(firstEl) +
        " - " +
        new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(lastEl)
      );
    };
  
      const confirmedHours = (confirmedHours, startTime, endTime) => {
        let hours = 0;
        if (confirmedHours == 0 || confirmedHours == null) {
          const start = moment(startTime, "HH:mm:ss");
          const end = moment(endTime, "HH:mm:ss");
  
          hours = timeDiff(start, end);
        } else {
          const string = String(confirmedHours);
          const numHours = string.split(".")[0];
          let minutes = string.split(".")[1];
  
          if (!minutes) {
            const time = numHours + ":" + "00";
            hours = String(time);
          } else {
            minutes = Number.parseFloat(`0.${minutes}`) * 60;
            hours = numHours + ":" + minutes.toFixed(0);
          }
        }
        return hours;
      };
  
      const formatHourlyRate = (regularRate, weekendRate) => {
        let formattedString = "";
  
        formattedString += regularRate ? "$" + regularRate : "";
        formattedString += regularRate && weekendRate ? " - " : "";
        formattedString += weekendRate ? "$" + weekendRate : "";
  
        return formattedString;
      };
  
      const showShiftInformation = (shift) => {
        if (!shift.userId) return true;
        if (shift.userId === userData.id) return true;
        return false;
      };
  
      const travelCompensationCount = (job, shift) => {
        if ((shift.travelCompensation >= 0 && shift.adminUpdatedTravelCompensation == true) || (shift.travelCompensation === 0 && shift.adminUpdatedTravelCompensation == true)) {
          return `$${shift.travelCompensation}`
        } else {
          if (
            job.settings.payingForTravel === 0 &&
            shift.adminUpdatedTravelCompensation == false
          ) {
            return "-";
          }
  
          if (job.settings.payingForTravel === 3 && job.maxTravelCompensation !== 0) {
            let travelCompensation;
            const globalTravelCompensationValue = process.env.VUE_APP_TRAVEL_COMPENSATION;
            let jobDistance;
  
            if (shift.distance) {
              jobDistance = shift.distance;
            } else {
              jobDistance = shift.historyDistance ? shift.historyDistance : job.distance;
            }
  
            if (jobDistance) {
              let distance = jobDistance;
              travelCompensation = distance * 2 * globalTravelCompensationValue;
              if (travelCompensation > job.maxTravelCompensation) {
                return `$${job.maxTravelCompensation}`;
              } else {
                travelCompensation = new Intl.NumberFormat("en-AU", {
                  style: "currency",
                  currency: "AUD",
                }).format(distance * 2 * globalTravelCompensationValue);
                return travelCompensation;
              }
            } else {
              return `$${job.maxTravelCompensation}`;
            }
  
          } else {
            return distance(job, shift);
          }
        }
      };
  
      const Sum = (shift) => {
        let Sum;
        let confirmedHoursVal;
        let payRate;
        let travelCompensation = 0;
        const globalTravelCompensationValue =
          process.env.VUE_APP_TRAVEL_COMPENSATION;
  
        if (userRole === "locum") {
          if (shift.locum == null && shift.payRateExecSuper == null) {
            payRate = shift.recommendedRate;
          } else {
            payRate = shift.payRateExecSuper;
          }
        } else {
          payRate = shift.payRateExecSuper;
        }
  
        if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
          const start = moment(shift.startTime, "HH:mm:ss");
          const end = moment(shift.endTime, "HH:mm:ss");
  
          confirmedHoursVal = timeDiffAsDecimal(start, end);
        } else {
          confirmedHoursVal = shift.confirmedHours;
        }
  
        if (shift.travelCompensation === 0 && shift.adminUpdatedTravelCompensation == false) {
          let jobDistance = shift.distance ? shift.distance : null;
  
          if (jobDistance === null && job.value.distance) {
            jobDistance = job.value.distance;
          }
  
          let distance = jobDistance;
  
  
          if (job.value.settings.payingForTravel == 1) {
            if (distance * 2 > 50) {
              travelCompensation =
                (distance * 2 - 50) * globalTravelCompensationValue;
            } else {
              // travelCompensation = shift.travelCompensation;
              travelCompensation = 0;
            }
          } else if (job.value.settings.payingForTravel == 2) {
            travelCompensation = distance * 2 * globalTravelCompensationValue;
          } else if (job.value.settings.payingForTravel === 3 && job.value.maxTravelCompensation !== 0) {
            let realTravelCost = distance * 2 * globalTravelCompensationValue;
            if (realTravelCost > job.value.maxTravelCompensation) {
              travelCompensation = job.value.maxTravelCompensation;
            } else {
              travelCompensation = distance * 2 * globalTravelCompensationValue;
            }
          }
  
          if (!job.value.settings.payingForTravel) {
            travelCompensation = 0;
          }
        } else {
          travelCompensation = shift.travelCompensation;
        }
  
        Sum = payRate * confirmedHoursVal + travelCompensation;
        if (Sum != 0) {
          Sum = new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(Sum);
        } else {
          Sum = "-";
        }
        return Sum;
      };
  
      const handleChange = (e) => {
        e.stoppropagation();
      };
  
      const distance = (job, shift) => {
        let result;
        const globalTravelCompensationValue =
          process.env.VUE_APP_TRAVEL_COMPENSATION;
  
        if (!shift.distance && !job.distance) {
          result = "-";
        } else {
          let distance;
          distance = shift.historyDistance ? shift.historyDistance : job.distance;
          if (job.settings.payingForTravel == 1) {
            if (distance * 2 > 50) {
              const result1 = (distance * 2 - 50) * globalTravelCompensationValue;
              result = new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
              }).format(result1);
            } else {
              result = "-";
            }
          } else if (job.settings.payingForTravel == 2) {
            result = new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(distance * 2 * globalTravelCompensationValue);
          } else if (job.settings.payingForTravel == 3) {
            result = new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(job.maxTravelCompensation);
          }
        }
  
        return result;
      };
  
      const Rate = (shift) => {
        if (userRole === "locum") {
          if (shift.locum == null && shift.payRateExecSuper == null) {
            return Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(shift.recommendedRate);
          } else {
            return Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(shift.payRateExecSuper);
          }
        }
      };
  
      const submit = () => {
        (async () => {
          try {
            // If the shift is already accepted/rejected, don't show the confirmation dialog
            if (shiftApplication.value.status !== 1) {
              return;
            }
            await ElMessageBox.confirm(
              "Are you sure you want to reward the shift?",
              "Reward Shift",
              {
                distinguishCancelAndClose: true,
                showConfirmButton: true,
                confirmButtonText: "Reward",
                cancelButtonText: "Cancel",
                confirmButtonClass: "el-button--success",
                cancelButtonClass: "el-button--grey",
                showClose: true,
                center: true,
              }
            );
          } catch {
            return;
          }
          try {
            const response = await $store.dispatch("AWARD_SHIFT", {
              application_id: $route.params.shiftAppId,
            });
            if (response.success) {
              ElMessage({
              type: "success",
              message: "Applicant removed successfully",
            });
              dialogVisible.value = true;
            } else {
              $router.push({ name: "search" });
            }
          } catch (error) {
            console.log(error);
          }
        })();
      };
  
      const goToSearch = () =>{
        $router.push({ name: "search" });
      }
  
      const rejectSubmit = () => {
        (async () => {
          try {
            // If the shift is already accepted/rejected, don't show the confirmation dialog
            if (shiftApplication.value.status !== 1) {
              return;
            }
            await ElMessageBox.confirm(
              "Are you sure you want to decline the shift?",
              "Decline Shift",
              {
                distinguishCancelAndClose: true,
                showConfirmButton: true,
                confirmButtonText: "Decline",
                cancelButtonText: "Cancel",
                confirmButtonClass: "el-button--danger",
                cancelButtonClass: "el-button--grey",
                showClose: true,
                center: true,
              }
            );
          } catch {
            return;
          }
          try {
            const response =  await $store.dispatch("REJECT_APPLICANT_BY_PHARMACY", {
                application_id: $route.params.shiftAppId,
              });
            if (response.success) {
              ElMessage({
              type: "success",
              message: "Applicant declined successfully",
            });
              rejectDialogVisible.value = true;
            } else {
              $router.push({ name: "shift_application_unavailable" });
            }
          } catch (error) {
            console.log(error);
          }
        })();
      };
  
      const redirectToCalendar = () => {
        $router.push({ name: "calendar" });
      };
  
      const isButtonDisabled = computed(() => {
        return shiftApplication.value.status !== 1;
      });
  
      const handleDialogClose = () => {
        // This function will be called when the dialog is fully closed
        goToSearch()
      };

    
  
      return {
        shift,
        job,
        userData,
        userRole,
        formatHourlyRate,
        showShiftInformation,
        travelCompensationCount,
        Sum,
        confirmedHours,
        handleChange,
        Rate,
        submit,
        rejectSubmit,
        dialogVisible,
        rejectDialogVisible,
        redirectToCalendar,
        isButtonDisabled,
        handleDialogClose,
        loading,
        pharmacy,
        formatHourlyRatePharmacy,
        checkJobDateStart,
        goBack,
        isAustralia,
        message
      };
    },
  }
  </script>